"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.deleteRole = deleteRole;
exports.getRoles = getRoles;
exports.getRoutes = getRoutes;
exports.updateRole = updateRole;
exports.updateUserRole = updateUserRole;
var _request = _interopRequireDefault(require("@/utils/request"));
// lifehikes
function updateUserRole(token, uuid, userRole) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = {
    role: userRole
  };
  return (0, _request.default)({
    url: `/users/${uuid}/role`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    headers,
    data
  });
}

// no use
function getRoutes() {
  return (0, _request.default)({
    url: '/vue-element-admin/routes',
    method: 'get'
  });
}
function getRoles() {
  return (0, _request.default)({
    url: '/vue-element-admin/roles',
    method: 'get'
  });
}
function addRole(data) {
  return (0, _request.default)({
    url: '/vue-element-admin/role',
    method: 'post',
    data
  });
}
function updateRole(id, data) {
  return (0, _request.default)({
    url: `/vue-element-admin/role/${id}`,
    method: 'put',
    data
  });
}
function deleteRole(id) {
  return (0, _request.default)({
    url: `/vue-element-admin/role/${id}`,
    method: 'delete'
  });
}